import { useEffect } from "react";

import errorImages from "common/constants/errorImages";
import { useListSearchState } from "common/hooks";
import { parseNumber } from "common/utils/numbers";

import Page from "client/common/components/layouts/Page";
import Body from "client/common/components/layouts/Body";
import Pagination from "client/common/components/layouts/Pagination";
import Subheader from "client/common/components/layouts/Subheader";
import Results from "client/common/components/results/Results";
import { Paths, urls } from "client/routes";

import Prescription from "./Prescription";
import { usePrescriptionsQuery } from "../hooks";

import styles from "../styles/PrescriptionsPage.module.less";

const Prescriptions = () => {
  const [search, updateSearch] = useListSearchState<Paths["prescriptions"]["list"]>({
    page: 1,
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [search.page]);

  const {
    data,
    isLoading,
    error: prescriptionsError,
  } = usePrescriptionsQuery({
    page: parseNumber(search.page, 1),
  });

  if (isLoading) {
    return <Results.Loading description="Loading prescriptions" />;
  }

  if (!data || prescriptionsError) {
    return (
      <Results.FetchError entityName="prescriptions" error={prescriptionsError} isPlural={true} />
    );
  }

  if (data.paginator.count === 0) {
    return (
      <Results.None
        image={errorImages.EmptyPrescriptions}
        header="You don't have any prescriptions."
        dest={urls.products.search()}
        button="Search Products"
      />
    );
  }

  return (
    <div className={styles.prescriptions}>
      {data.results.map((prescription) => (
        <Prescription key={prescription.id} prescription={prescription} />
      ))}
      <Pagination
        paginator={data.paginator}
        onPageChange={(page) => updateSearch({ page })}
        entityName="prescription"
      />
    </div>
  );
};

const PrescriptionsPage = () => {
  return (
    <Page>
      <Subheader
        classNames={{ actions: styles.actions }}
        title="My Pet's Prescriptions"
        description="Easily fill my pet's medications"
      />
      <Body>
        <Prescriptions />
      </Body>
    </Page>
  );
};

export default PrescriptionsPage;
